// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleExceptionsRequester = {
  id: "exceptions-requester",
  mrn: "//iam.api.mondoo.app/roles/exceptions-requester",
  title: "Exception Requester",
  allowedActions,
} as const;

export type RoleExceptionsRequester = typeof roleExceptionsRequester;
